<div class="image-upload-button-container">
  <span class="label" [style.background-color]="backdropColor" [translate]="labelText"></span>
  <div class="upload-box">
    @if (images && images.length) {
      <div class="preview-image-container" matRipple (click)="handleChooseImageClick()">
        <gb-image [image]="images[0]" [cover]="cover"></gb-image>
      </div>
      @if (isMulti) {
        <div class="preview-image-row-container">
          @for (preview of previews; track preview) {
            <div class="small-preview-image" matRipple (click)="handleChooseImageClick()">
              @if (images[preview + 1]) {
                <gb-image [image]="images[preview + 1]" [cover]="cover"></gb-image>
              }
            </div>
          }
        </div>
      }
    }
    @if (!images || (images.length === 0 && showEmptyImageArea)) {
      <div class="empty-image-area" matRipple (click)="handleChooseImageClick()">
        <gb-icon icon="image"></gb-icon>
      </div>
    }
    @if (maxWidth && maxHeight) {
      <mat-hint class="image-size-hint">
        <span
          translate="SHARED.IMAGE_UPLOADER.RECOMMENDED_SIZE"
          [translateParams]="{ width: maxWidth, height: maxHeight }"
        ></span>
      </mat-hint>
    }

    <button mat-flat-button (click)="handleChooseImageClick()" [disabled]="disabled" type="button">
      <span [translate]="buttonText"></span>
    </button>

    @if (secondaryButtonText) {
      <button mat-stroked-button type="button" (click)="handleSecondaryButtonClick()">
        <span [translate]="secondaryButtonText"></span>
      </button>
    }

    <ng-content></ng-content>
  </div>
</div>
